// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__ZqIpW","disabled":"Input_disabled__NfT9S"};